export function formatDiseaseName(cuiName: string | undefined | null): string {
  if (!cuiName) return '';
  return cuiName
    .split(', ')
    .map(part =>
      part
        .toLowerCase()
        .split(' ')
        .map(w => w.charAt(0).toUpperCase() + w.slice(1))
        .join(' '),
    )
    .join(', ');
}

export function formatNumber(n: number | null | undefined): string {
  if (n == null || !Number.isFinite(n)) return '0';
  return n.toLocaleString('en-US');
}

export function formatPadj(padj: number): string {
  if (padj < 0.001) return padj.toExponential(1);
  return padj.toFixed(3);
}

export function formatLog2Fc(fc: number): string {
  const sign = fc >= 0 ? '+' : '';
  return `${sign}${fc.toFixed(3)}`;
}
